import { collection, get, all, query, where, update } from "typesaurus"
import { LicenseType } from "../types"

export interface AccountLicense {
  id: string
  district?: string
  accountId?: string
  created: number
  lastModified: number
  startDate: number
  endDate: number
  licenceSet: string
  licenseType: LicenseType
  licenseCount: number
  licenseMax: number
  name: string
  navCategory: string
  navName: string
  licensedUsers: { [key: string]: boolean }
  deleted?: boolean
  isExpired?: boolean
}

const collection_ref = collection<AccountLicense>("accountLicenses")

export const getLicenseById = (id: string) => {
  return get(collection_ref, id)
}

export const getAllLicenses = () => {
  return all(collection_ref)
}

export const getLicenseWhereId = (id: string) => {
  return query(collection_ref, [where("id", "==", id)])
}

export const updateLicenseById = (
  id: string,
  newVals: Partial<AccountLicense>
) => {
  return update(collection_ref, id, newVals)
}

export const getLicenseWhereAccountId = (accountId: string) => {
  return query(collection_ref, [where("accountId", "==", accountId)])
}

export const getLicenseWhereDistrictId = (district: string) => {
  return query(collection_ref, [where("district", "==", district)])
}
